define([
	'internal_util/Util',
	'internal_util/Logger',
	'model/ActivationType',
	'model/Error',
	'model/ErrorType',
	'service/Core',
	'service/EventListenerRegistry',
	'service/UIStateManager',
	'interceptor/StateChangeInterceptor',
	'amdi18n-loader?!service/interceptor/nls/StateChangeInterceptor_strings',
	'amdi18n-loader?!service/interceptor/nls/RecoveryStrategyInterceptor_strings'

], function (
	Util,
	Logger,
	ActivationType,
	Error,
	ErrorType,
	Core,
	EventListenerRegistry,
	UIStateManager,
	StateChangeInterceptor,
	GenericStrings,
	Strings
) {
	'use strict';

	/**
	 * RecoveryStrategyInterceptor class
	 */
	function RecoveryStrategyInterceptor(core, uiStateManager) {
		var _maxDetectionAge = 5000, // in msecs
			_core,
			_uiStateManager,
			_skipNext = false;

		if (core instanceof Core) {
			_core = core;
		} else {
			throw new Error('no valid core found');
		}

		if (uiStateManager instanceof UIStateManager) {
			_uiStateManager = uiStateManager;
		} else {
			throw new Error('no valid uiStateManager found');
		}

		StateChangeInterceptor.call(this);


		// private methods

		function log(method, message, data) {
			Logger.log('RecoveryStrategyInterceptor', method, message, data);
		}

		function callLog(method, message, data, event, callbacks) {
			log(method, message, data);
			EventListenerRegistry.callListeners(event, data, function () {
				Util.callCallbacks(callbacks, data);
			});
		}



		// public methods

		this.intercept = function (previous, next) {
			var _name = 'intercept',
				authenticationOption,
				recoveryStrategies;

			if (_skipNext) {
				_skipNext = false;
				return false;
			}

			if (next['state'].id() === 'activation'
					&& previous['state'] !== null && previous['state'].id() !== 'recovery_strategy') {
				authenticationOption = next['data']['authenticationOption'];

				if (!authenticationOption.cloudID() && authenticationOption.activation() === ActivationType.EID_CLIENT) {
					callLog(_name, GenericStrings.state_interception_started,
							{ previous : previous['state'], next :  next['state'] }, 'UI_STATE_INTERCEPTION_STARTED', function () {
						function checkAndStart() {
							callLog(_name, GenericStrings.state_interception_finished,
									{ previous : previous['state'], next : next['state'] }, 'UI_STATE_INTERCEPTION_FINISHED', function () {
								if (!_core.eidClientManager().eidClientAvailable(authenticationOption)) {
									recoveryStrategies = _core.recoveryStrategyManager().getRecoveryStrategies(authenticationOption);

									if (recoveryStrategies.length > 0) {
										_uiStateManager.change('recovery_strategy',
												{ recoveryStrategies : recoveryStrategies, activationData : next['data'] });
									} else {
										_uiStateManager.change('error',
												new Error(ErrorType.NON_RECOVERABLE, Strings.no_matching_recovery_strategy_found,
														authenticationOption));
									}
								} else {
									_skipNext = true;
									_uiStateManager.change('activation', next['data']);
								}
							});
						}

						if (_core.eidClientManager().lastDetectionRun() === null
								|| ((new Date()).getTime() - _core.eidClientManager().lastDetectionRun().getTime()) > _maxDetectionAge) {
							EventListenerRegistry.addOneTimeListener('EID_CLIENT_DETECTION_CYCLE_FINISHED', function () {{
								_core.eidClientManager().stopDetection(authenticationOption);

								checkAndStart();
							}});

							_core.eidClientManager().startDetection(authenticationOption);
						} else {
							checkAndStart();
						}
					});

					return true;
				}
			}

			return false;
		};
	}

	RecoveryStrategyInterceptor.prototype = Object.create(StateChangeInterceptor.prototype);

	return RecoveryStrategyInterceptor;
});



//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/service/interceptor/RecoveryStrategyInterceptor.js
// module id = 366
// module chunks = 4